module.exports = __webpack_public_path__ + "img/emily-altman-headshot.10c8f0bb.jpg";